module.exports = __webpack_public_path__ + "static/60_anos-b42f2d40229ea85d6e9392e5a7da9ec0.png";